import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./home/HomePage";
import JobFormPage from "./jobPages/JobFormPage";
import CustomerReferenceForm from "./CustomerLogosPage/CustomerReferenceForm";
import DashBoard from "./jobPages/DashBoard";
import { API_ENDPOINTS } from "./config";
import ProtectedRoute from "./authentication/protectedRoute";
import RegisterPage from "./registerPage/registerPage";
import CreateNewBlogPage from "./blogPages/CreateNewBlogPage";
import JobFormNew from "./jobPages/JobFormNew";
import SelectDivision from "./selectDivisonScreen/SelectDivision";
import { Buffer } from 'buffer';
import process from 'process/browser';
import GoogleMapComponent from "./googleMap/googleMap";
import './localization/i18n';
import JobFormV2 from "./jobPages/JobformV2";
import NewGoogleMapComponent from "./googleMap/newGoogleMap"; // import the i18n configuration file


// Make Buffer and process available globally
window.Buffer = Buffer;
window.process = process;



export default function App() {
    return (
        //<RegisterPage></RegisterPage>
        <BrowserRouter>
            <Routes>
                <Route path="/map" 
                        element={<GoogleMapComponent/>
                }/>
                <Route path="/new-google-map"
                       element={<NewGoogleMapComponent/>}
                />
                <Route path="/" element={
                    <HomePage />
                } />
                <Route path="/division" element={
                    <SelectDivision/>
                }/>
                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <DashBoard/>
                    </ProtectedRoute>
                } />
                <Route path= 'job-form/:lang/:id' element={
                    <ProtectedRoute>
                        <JobFormV2></JobFormV2>
                    </ProtectedRoute>
                } />
                <Route path= 'job-form/:lang' element={
                    <ProtectedRoute>
                        <JobFormV2></JobFormV2>
                    </ProtectedRoute>

                } />
                <Route path= 'job-form-new/:lang/:id' element={
                    <ProtectedRoute>
                        <JobFormV2></JobFormV2>
                    </ProtectedRoute>
                } />
                <Route path= 'job-form-new/:lang' element={
                    <ProtectedRoute>
                        <JobFormV2></JobFormV2>
                    </ProtectedRoute>    
                } />
                <Route path= 'job-form' element={
                    <ProtectedRoute>
                        <JobFormV2></JobFormV2>
                    </ProtectedRoute>
                } />
                <Route path='/reference-form/:id' element={
                    <ProtectedRoute>
                        <CustomerReferenceForm/>
                    </ProtectedRoute>
                }/>
                <Route path='/reference-form' element={
                    <ProtectedRoute>
                        <CustomerReferenceForm/>
                    </ProtectedRoute>
                }/>
                <Route path='/blog-form/:id/:lang' element={
                    <ProtectedRoute>
                        <CreateNewBlogPage/>
                    </ProtectedRoute>
                }/>
                <Route path='/blog-form/:id/:lang/:duplicate' element={
                    <ProtectedRoute>
                        <CreateNewBlogPage/>
                    </ProtectedRoute>
                }></Route>
                <Route path='/blog-form' element={
                    <ProtectedRoute>
                        <CreateNewBlogPage/>
                    </ProtectedRoute>
                }/>
            </Routes>
        </BrowserRouter>
    );
}

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);